import {
  Bone, Fish, Cookie, Gamepad2, Scissors, Sparkles, Link2, Sofa, Coffee,
  HeartPulse, Target, Car, PawPrint, Dog, Cat,
} from "lucide-react";

export const ICONS = {
  Bone, Fish, Cookie, Gamepad2, Scissors, Sparkles,
  Link: Link2, Link2, Sofa, Coffee, HeartPulse, Target, Car, PawPrint, Dog, Cat,
};

export function getIcon(name) {
  return ICONS[name] || PawPrint;
}

export const CATEGORIES = [
  { key: "Dog Food", icon: "Bone", color: "#FF7A45", desc: "Daily kibble & wet meals for dogs." },
  { key: "Cat Food", icon: "Fish", color: "#38BDF8", desc: "Tasty meals for kittens & adult cats." },
  { key: "Treats", icon: "Cookie", color: "#FBBF24", desc: "Training rewards & guilty-free snacks." },
  { key: "Toys", icon: "Gamepad2", color: "#A3E635", desc: "Fetch, chase, chew — the fun stuff." },
  { key: "Grooming", icon: "Scissors", color: "#F472B6", desc: "Shampoos, brushes & spa essentials." },
  { key: "Litter & Cleaning", icon: "Sparkles", color: "#A78BFA", desc: "Clumping litter & cleaning gear." },
  { key: "Collars/Leashes", icon: "Link", color: "#0F172A", desc: "Walks, harnesses & ID tags." },
  { key: "Beds & Comfort", icon: "Sofa", color: "#FCA5A5", desc: "Cozy beds, blankets & cat caves." },
  { key: "Bowls & Feeders", icon: "Coffee", color: "#94A3B8", desc: "Bowls, feeders & water fountains." },
  { key: "Health & Care", icon: "HeartPulse", color: "#F87171", desc: "Vitamins, dental & first-aid." },
  { key: "Training Essentials", icon: "Target", color: "#34D399", desc: "Clickers, pads & puppy starter kits." },
  { key: "Travel & Carriers", icon: "Car", color: "#818CF8", desc: "Carriers, harnesses & on-the-go gear." },
];
